export default __webpack_public_path__ + "static/media/foot-left-inside.29cb4fa6.png";